module.exports = __webpack_public_path__ + "img/weihu.18cdbc18.jpg";